import CloseIcon from '@mui/icons-material/Close';
import * as Styles from './TagOption.styles';

type TagOptionProps = {
  isDisabled?: boolean;
  optionLabel: string;
  onRemoveItem: () => void;
  backgroundColor?: string;
};

const TagOptionComponent = function ({
  optionLabel,
  isDisabled = false,
  onRemoveItem,
  backgroundColor,
}: TagOptionProps): JSX.Element {
  return (
    <Styles.OptionContainer
      $isDisabled={isDisabled}
      data-testid={`${optionLabel}-option-rendered`}
      $backgroundColor={backgroundColor}
    >
      {optionLabel}

      {!isDisabled && (
        <Styles.DeleteButton
          disabled={isDisabled}
          type="button"
          onClick={onRemoveItem}
          data-testid={`remove-${optionLabel}-btn`}
        >
          <CloseIcon sx={{ color: '#6F7175', width: '12px', height: '12px' }} />
        </Styles.DeleteButton>
      )}
    </Styles.OptionContainer>
  );
};

export default TagOptionComponent;
